








import { Component, Vue, Prop } from "vue-property-decorator";
import { AccessLogUserModel } from "../models";
import AccessLogUserPanel from "./AccessLogUserPanel.vue";

@Component({
  components: { AccessLogUserPanel },
})
export default class AccessLogUsers extends Vue {
  @Prop({ required: true })
  value!: AccessLogUserModel[];
}
